export const POSTHOG_KEYS = {
  local: "phc_eGUS4WrPcnXWXn24v0nnTMA9aVIe6K7U8qY1HfJjM1J",
  development: "phc_eGUS4WrPcnXWXn24v0nnTMA9aVIe6K7U8qY1HfJjM1J",
  sandbox: "phc_eGUS4WrPcnXWXn24v0nnTMA9aVIe6K7U8qY1HfJjM1J",
  staging: "phc_eGUS4WrPcnXWXn24v0nnTMA9aVIe6K7U8qY1HfJjM1J",
  production: "phc_6owBQTbz93ArDLq3PTXu6zgv2d58mvN5pgCHELN8xgY",
};
